/* @HEADER
 * @version 1.1.1298 | 2026-10-30
 * @purpose ZVX-DEV-8719 -- a version number that moves when the organisation stamp wrote to the project registry, so the component that holds it renders again and every sync mount below it asks for the organisation of its project anew.
 * @sidecar useProjectOrganizationsStamped.ts.header.md
 * @layer hook | @hex adapter | @ctx project
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-8719

import { useEffect, useState } from 'react'
import { PROJECT_ORGANIZATIONS_STAMPED_EVENT } from '../lib/projectOrganizationsStampedEvent'

export function useProjectOrganizationsStamped(): number {
  const [version, setVersion] = useState(0)
  useEffect(() => {
    const onStamped = () => setVersion((n) => n + 1)
    window.addEventListener(PROJECT_ORGANIZATIONS_STAMPED_EVENT, onStamped)
    return () => window.removeEventListener(PROJECT_ORGANIZATIONS_STAMPED_EVENT, onStamped)
  }, [])
  return version
}
